module.exports = {
  /** A string set as delete reason in _delete document_ requests. */
  docDeleteStaticReason: 'Document deleted by user',
  /** An array of strings; list of docTypes that shall be deletable via the UI. */
  deletableDocTypes: ['medication', 'vitamin'],
  doctorRole: 'HCP_USER',
  neuropsychologistRole: 'NEUROPSYCHOLOGIST',
};
